module.exports = __webpack_public_path__ + "img/SOLEIL.45b9b386.png";